module.exports = __webpack_public_path__ + "static/media/logo.359ffd6e.svg";